import { LoadingOutlined } from '@ant-design/icons';
import React, { useEffect } from "react";
import { Spin } from 'antd';

const antIcon = <LoadingOutlined style={{ fontSize: 36 }} spin />;

const styles = `
.LoadingActionWrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(30, 30, 46, 0.6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  z-index: 9999;
}
`;

const LoadingAction = () => {
    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, []);

    return (
        <div className="LoadingActionWrapper">
            <Spin indicator={antIcon} />
        </div>
    );
}

export default LoadingAction;
